<div
  class="d-flex align-items-center shift-card text-truncate"
  [class.transfer-card]="isTransferCard"
>
  <div class="d-block shift-card-text">
    <div class="mb-0 d-flex justify-content-between">
      <span class="text-truncate locations align-items-start flex-grow-1">{{
        startLocation
      }}</span>
      <span class="text-truncate locations align-items-end text-end">{{
        endLocation
      }}</span>
    </div>
    <div class="mb-0 text-truncate d-flex justify-content-between">
      <span>
        {{ startDateTime | localizedDateFormat }}
      </span>
      <span>
        {{ endDateTime | localizedDateFormat }}
      </span>
    </div>
    <div class="mb-0 text-truncate d-flex justify-content-between">
      <span>
        {{ startDateTime | localizedTimeFormat }}
      </span>
      <span>
        {{ endDateTime | localizedTimeFormat }}
      </span>
    </div>
  </div>
</div>
